import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Text from "@components/Text";
import { themeDefault } from "src/theme-revamp";
import Stepper from "@components/_Revamp/Stepper";
import Accordion from "@components/_Revamp/Accordion";
import Button from "@components/_Revamp/Button";
import { useAvivaSelector } from "@redux/hook";
import {
  RadioButton,
  RadioButtonGroup,
} from "@components/_Revamp/RadioButton/RadioButton";
import Bullet from "@components/_Revamp/Bullet";
import Input from "@components/_Revamp/Input";
import { calculateSpacer } from "../../../utils/spaceCalculation";
import { scrollToRef } from "../../../utils/scrollScript";
import {
  getPolicyNo,
  postComputePremium,
  postGetPersonalDetails,
  postPayment,
  savePayment,
  sendMailMltc,
} from "@api/index";
import { AgentPersonalDetailRequest } from "@models/AgentPersonalDetailRequest.model";
import { find, get, isEmpty } from "lodash";
import { postRetrieveInformation } from "@api/index";
import {
  updateAgentDetailResponseRaw,
  updateBankId,
  updateCardHolderName,
  updateOtherBank,
  updatePolicyNo,
  updateReferenceNo,
} from "@redux/slices/MLTC_R3/step5Slice";
import { useDispatch } from "react-redux";
import Icon from "@components/_Revamp/Icon";
import { SQSPocketResponse } from "@models/MLTC/SQSPocketRequest.model";
import { Coverages } from "@models/MLTC/SQSPocketRequest.model";
import { Helpers } from "@utils/helpers";
import { PaymentRequest } from "@models/MLTC/PaymentRequest.model";
import useForm from "@utils/useForm";
import { PaymentForm } from "@models/MLTC_R3/Payment.model";
import { GAAviva, MLTC_R3_JOURNEY_NAME } from "@utils/gaAvivaR3";
import { useHistory } from "react-router-dom";
import { validate } from "./service";
import {
  setLoadingState,
  setIsGlobalError,
  setInvalidArcCodeFromUrl,
} from "@redux/slices/loadingSlice";
import { Step } from "@components/_Revamp/Stepper/Stepper";
import BottomSheet from "@components/_Revamp/BottomSheet";
import { updateUrlParam } from "@redux/slices/MLTC_R3/urlAnalyticSlice";
import { UrlAnalyticTrackingModel } from "@models/MLTC_R3/UrlAnalytic.model";
import { mask } from "@utils/mask";
import {
  updateAdvisorSelection,
  updateAgentCode,
} from "@redux/slices/MLTC_R3/step6Slice";
import { store } from "@redux/store";
import InnerContainer from "@components/_Revamp/InnerContainer";
import { SCREEN_SIZE } from "@static/screen-size";
import { InputGroup } from "@components/_Revamp/InputGroup";
import ArcForm from "./ArcForm";

export interface AdvisorProps {}

export interface EditBtnProps {
  onClick?: (e: any) => void;
}

const Advisor = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  //-SELECTOR from R3
  const quoteRawResponse = useAvivaSelector(
    (state) => state.mltcR3Step2.quoteRawResponse
  );
  const quoteRawRequest = useAvivaSelector(
    (state) => state.mltcR3Step2.quoteRawRequest
  );
  const planDetails = useAvivaSelector(
    (state) => state.mltcR3Step2.planDetails
  );
  const promoCodeSummary = useAvivaSelector(
    (state) => state.mltcR3Step2.appliedPromoCode
  );
  const premiumPayment = useAvivaSelector(
    (state) => state.mltcR3Step5.premiumPaymentMethod
  );
  const retrieveMyInfo = useAvivaSelector(
    (state) => state.mltcR3Step4.retrievedMyInfo
  );
  const sqsQuotation = useAvivaSelector(
    (state) => state.mltcR3Step2.sqsQuotation
  );
  const initValue = useAvivaSelector((state) => state.mltcR3Step1.coverage);
  const basicDetails = useAvivaSelector(
    (state) => state.mltcR3Step1.basicDetails
  );
  const rawAgentDetailResponse = useAvivaSelector(
    (state) => state.mltcR3Step5.agentDetailResponseRaw
  );
  const personalDetails = useAvivaSelector(
    (state) => state.mltcR3Step4.personalDetails
  );
  const advisorData = useAvivaSelector(state=>state.mltcR3Step6)
  const bankId = useAvivaSelector((state) => state.mltcR3Step5.bankId);
  const otherBank = useAvivaSelector((state) => state.mltcR3Step5.otherBank);
  const showArcPage = useAvivaSelector((state) => state.mltcR3Step5.showArcPage);
  const myInfoForm = useAvivaSelector((state) => state.mltcR3Step4.myInfoForm);
  const previousAdvisorSelection = useAvivaSelector(
    (state) => state.mltcR3Step6.advisorSelection
  );
  const previousAgentCode = useAvivaSelector(
    (state) => state.mltcR3Step6.agentCode
  );
  //--------------------
  //-SELECTOR from previous, incomeInfo not available in R3
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const [campaignCode, setCampaignCode] = useState<string>("MLO1");

  //--------------------

  const isCpfOnly = useAvivaSelector((state) => state.mltcR3Step5.isCPFOnly);
  const paymentInfoData = useAvivaSelector(
    (state) => state.mltcR3Step5.paymentInfoData
  );
  const isInvalidArcCodeFromUrl = useAvivaSelector(
    (state) => state.loading.isInvalidArcCodeFromUrl
  );

  const [isLoading, setLoading] = useState<boolean>(false);
  const [isPaymentClick, setIsPaymentClick] = useState<boolean>(false);
  const [advisorSelection, setAdvisorSelection] = useState("");
  const [agentCode, setAgentCode] = useState<string>("");
  const [isAdvisorFound, setAdvisorFound] = useState<boolean>(false);
  const [advisorName, setAdvisorName] = useState<string>("");
  const [advisorSourceOfBusiness, setAdvisorSourceOfBusiness] =
    useState<string>("");
  const [agentCodeFormMsg, setAgentCodeFormMsg] = useState<string>("");
  const [hasError, setHasError] = useState<boolean>(false);

  const modalContainerRef = useRef<null | HTMLDivElement>(null);
  const agentCodeFormRef = useRef<HTMLDivElement | null>(null);
  const advisorSelectionFormRef = useRef<HTMLDivElement | null>(null);
  const SpacerRef = useRef<HTMLDivElement | null>(null);
  const transactionId = useAvivaSelector(
    (state) => state.mltcR3Step2.transactionId
  );
  const agentInformationResponseRaw = useAvivaSelector(
    (state) => state.mltcR3Step5.agentInformationResponseRaw
  );
  const paramCC = campaignDetail?.campaignCode
    ? `?cc=${campaignDetail.campaignCode}`
    : "";
  const analyticUrlParams = useAvivaSelector(
    (state) => state.urlAnalytic.param
  );
   const gioDeclaration = useAvivaSelector(state => state.mltcR3Step2.gioDeclaration);
   const cstopupCampaignValidity = useAvivaSelector(
     (state) => state.mltcR3Step2.cstopupCampaignValidity,
   );
   const qrClientDetails = useAvivaSelector(
     (state) => state.mltcR3Step5.qrClientDetails,
   );
   const validQRClient = qrClientDetails?.status === "SUCCESS";
  const analyticParam = Helpers.getUrlAnalyticParams(
    paramCC !== "",
    analyticUrlParams
  );
  const { values, errors, handleChange, patchValue, formValid } = useForm(
    new PaymentForm(paymentInfoData),
    () => {},
    () => {}
  );

  const trackOnLoad = ({ formName = "", policyID = "" }): void => {
    const GA = GAAviva.getInstance();
    let { form, acquisition, page } = GA.digitalData;
    form.name = formName;
    acquisition.product.policyID = policyID;

    // QB-AA-Tracking fix: step 18 ("Financial Adviser") of the journey.
    page.journeyName = MLTC_R3_JOURNEY_NAME;
    page.stepName = "Financial Adviser";
    page.stepNumber = "18";

    GA.trackPageLoad({ acquisition, form, page });
  };
  const trackOnAgencySelection = (value: string, role: string) => {
    const GA = GAAviva.getInstance();
    let { acquisition, internal } = GA.digitalData;
    acquisition.customer.servicingMode =
      value === "USER_PREFERRED"
        ? "I have a FA in mind"
        : value === "ARISTOTLE"
        ? "I want Singlife to assign"
        : value === "NO_AGENT"
        ? "No, I do not need"
        : "";
    internal.account.role = role;
    GA.trackPageLoad({ acquisition });
  };

  const trackOnAgencyCode = (agentCode: string, role: string) => {
    const GA = GAAviva.getInstance();
    let { internal } = GA.digitalData;
    internal.account.id = agentCode; //
    internal.account.role = role; //Agent or Direct
    GA.trackPageLoad({ internal });
  };

  //Process from previous payment.tsx onClickConfirmAndPay -> processPayment -> onSavePayment -> onSuccessPayment
  //TODO : Get previous data from step 1 to 4;
  useEffect(() => {
    //TODO : Check if previous steps is completed, else redirected to step 1;

    if (!paymentInfoData) {
      history.push("/mltc/lets-get-started" + paramCC + analyticParam);
      return;
    }
    if (!store.getState().mltcR3Step5.isPaymentInfoCompleted) {
      history.push("/mltc/prepayment" + paramCC + analyticParam);
      return;
    }

    if (advisorSelectionFormRef && advisorSelectionFormRef.current) {
      advisorSelectionFormRef.current.style.opacity = "1";
      calculateSpacer(advisorSelectionFormRef, SpacerRef, true);
    }

    trackOnLoad({ formName: "mltc_agency_form" });
  }, []);

  useEffect(() => {
    if (campaignDetail) {
      setCampaignCode(campaignDetail?.code);
    }
  }, [setCampaignCode, campaignCode]);

  useEffect(() => {
    if (analyticUrlParams.arc) {
      setAdvisorSelection("USER_PREFERRED");
      setAgentCode(analyticUrlParams.arc);
    }else if(advisorData.advisorSelection  === "USER_PREFERRED"){
      setAdvisorSelection("USER_PREFERRED");
      setAgentCode(advisorData.agentCode);

    }
    if (isInvalidArcCodeFromUrl) {
      setAdvisorSelection("USER_PREFERRED");
    }
    
  }, [analyticUrlParams, isInvalidArcCodeFromUrl]);

  const onClickVerify = async () => {
    console.log(`QnB ➤ onClickVerify(agentCode)`, { agentCode });
    

    try {
      dispatch(setLoadingState(true));
      const response = await postGetPersonalDetails(
        new AgentPersonalDetailRequest({ agentCode: agentCode.replace(' ', '') })
      );
     
      const data = get(response, "data.data", null);
      // const data = get(dataMock, 'data', null);
      const responseInfo = await postRetrieveInformation({
        sourceSystem: "MLTC",
        loggedInUserId: 0,
        clientNum: data?.clientNum,
        agentNo: agentCode.replace(' ', ''),
      });
      const dataInfo = get(responseInfo, "data", null);
      const agentCoy = find(dataInfo, { agentCoy: "1" });
      console.log({ responseInfo, dataInfo, agentCoy });
      dispatch(updateAgentDetailResponseRaw(data));
      console.debug("postGetPersonalDetails", { data, response });

      if (
        data?.fullName &&
        !isEmpty(data?.fullName) &&
        data?.agentTerminatedFlag !== "Y"
      ) {
        setAdvisorName(data?.fullName);
        setAdvisorSourceOfBusiness(agentCoy.sourceOfBusiness);
        setAgentCodeFormMsg(
          `${mask(
            data?.fullName
          )} has been assigned as your Financial Adviser Representative for this policy`
        );
        setAdvisorFound(true);
        trackOnAgencyCode(agentCode, "Agent");
        dispatch(setInvalidArcCodeFromUrl(false));
      } else {
        setAdvisorName("");
        setAdvisorSourceOfBusiness("");
        setAgentCodeFormMsg(
          "We couldn't find an adviser with the code you provided. Try another code."
        );
        setAdvisorFound(false);
        trackOnAgencyCode("", "Direct");
      }
      dispatch(setLoadingState(false));
    } catch (error) {
      console.error("error", error);
      setAdvisorName("");
      setAdvisorSourceOfBusiness("");
      setAgentCodeFormMsg(
        (error as any).response.status === 405
          ? "We couldn't find an adviser with the code you provided. Try another code."
          : "We couldn't find an adviser with the code you provided. Try another code."
      );
      dispatch(updateAgentDetailResponseRaw(null));
      setAdvisorFound(false);
      setTimeout(() => {
        dispatch(setLoadingState(false));
      }, 1000);
      trackOnAgencyCode("", "Direct");
      dispatch(updateUrlParam({ ...analyticUrlParams, arc: "", pm: "", qrCd: "" }));
    }
    finally {
      dispatch(setLoadingState(false));
    }
  };

  const onAgentCodeChange = (e: any) => {
    setAgentCode((prev) => {
      if (e.target.value.length > 9) {
        return prev;
      }
      let input = e.target.value.trim();
      const regex = /^[0-9]{0,4}\s{0,1}[0-9]{0,4}$/;
      if (!regex.test(input)) {
        return prev;
      }
      if (input.includes(" ")) {
        input = input.slice(0, 4) + " " + input.slice(5);
      } else if (input.length > 4) {
        input = input.slice(0, 4) + " " + input.slice(4);
      }
      dispatch(updateAgentCode(e.target.value));
      return input;
    })

    setAdvisorFound(false);
    setAgentCodeFormMsg("");
    setAdvisorName("");
    setAdvisorSourceOfBusiness("");
  };

  const onClickConfirmAndPay = async () => {
    if (isPaymentClick) return;
    setIsPaymentClick(true);
    setTimeout(() => {
      setIsPaymentClick(false);
    }, 5000);

    const promoCode = get(
      quoteRawRequest,
      "coverages[0].attributes.promoCodeSummary",
      ""
    );
    console.log("onClickConfirmAndPay", {
      promoCodeSummary,
      quoteRawRequest,
      promoCode,
    });
    //Disabled this flow for R3
    // validatePromoCode(promoCode)
    // if (!(await validatePromoCode(promoCode))) {
    //   //toggleModalPromoCode();
    //   return;
    // }
    await processPayment();
  };

  const validatePromoCode = useCallback(
    async (promoCode: any) => {
      console.log("validatePromoCode", promoCode);
      if (isEmpty(promoCode)) {
        return true;
      }
      const payload = { ...quoteRawRequest };
      // set(payload, 'coverages[0].attributes.promoCodeSummary', promoCodeSummary);
      const response = await postComputePremium(payload, true);
      const data = get(response, "data.data", {});
      const pocket = new SQSPocketResponse(data);
      const checkedCode = pocket.checkValidPromoCode(promoCode);
      const { valid } = checkedCode;
      return valid;
    },
    [quoteRawRequest, promoCodeSummary]
  );

  const processPayment = async () => {
    dispatch(setLoadingState(true));
    const pocket = new SQSPocketResponse(quoteRawResponse);
    const coverage: Coverages | undefined = find(pocket.coverages, {
      type: "P",
    });
    // const totalPayablePremium = Number(pocket.mltcPremium.totalPremium.value.toString().replace('S$', '')) || 1; // for testing
    // const totalPayablePremium = parseFloat(premiumPayment?.creditCardAmount).toFixed(2);
    console.log(
      "premiumPayment?.creditCardAmount",
      premiumPayment?.creditCardAmount
    );
    const totalPayablePremium = Helpers.toTwoDecimal(
      premiumPayment?.creditCardAmount
    );

    const payload = new PaymentRequest({
      transactionId,
      amount: totalPayablePremium,
      productName: "MLTC",
      contractCode: coverage?.productCode || "",
    });
    console.log("processPayment data", payload, coverage?.productCode);
    onSavePayment(coverage?.productCode || "" || "", payload);
  };

  const onSavePayment = useCallback(
    async (contractCode: string, paymentPayload: any, policyNo?: string) => {
      const quotation: SQSPocketResponse = new SQSPocketResponse(
        quoteRawResponse
      );
      const coverage: Coverages | undefined = find(quotation.coverages, {
        type: "P",
      });
      // const totalPayablePremium = Number(quotation.dpiPremium.totalPremium.value.toString().replace('S$', '')) || 1;
      const totalPayablePremium = premiumPayment?.creditCardAmount;
      let sourceOfFunds = "";
      console.log("onSavePayment isCPFONly", isCpfOnly);
      if (!isCpfOnly) {
        values["fund"]?.forEach((item: string) => {
          const f_item = item === "other" ? `OTH` : item;
          sourceOfFunds = sourceOfFunds
            ? `${sourceOfFunds}|${f_item},${
                item === "other" ? values["otherFund"] : "Y"
              }`
            : `${f_item},${item === "other" ? values["otherFund"] : "Y"}`;
        });
      }
      const cpfAmt = premiumPayment?.cpfMediSaveAmount || 0;
      const ccAmt = premiumPayment?.creditCardAmount || 0;
      const dataInfo = get(agentInformationResponseRaw, "data", null);
      const agentCoy = find(dataInfo, { agentCoy: "1" });
      const rawAgentSourceOfBusiness = agentCoy?.sourceOfBusiness;
      const campaigns = [
        ...(gioDeclaration === "GIO"
          ? [{ code: "GIO", campaignDeclaration: true }]
          : gioDeclaration === "NON GIO"
          ? [{ code: "GIO", campaignDeclaration: false }]
          : []),

        ...(cstopupCampaignValidity ? [{ code: "CSTOPUP" }] : []),
      ];
      const payload = {
        policy: {
          // "policyNumber": policyNo,
          contractCode: contractCode,
          customerId: retrieveMyInfo?.id,
          productId: 3,
          planName: coverage?.name,
          sumAssured: quotation.monthlyBenefit,
          premiumTerm: planDetails?.premiumTerm || sqsQuotation?.premiumTerm,
          premiumAmount: coverage?.attributes?.modalPremium,
          premiumPaymentFrequency:
            quotation.coverages[0].attributes?.planPremiumMode,
          totalAnnualPremium: quotation.nonDiscountedTotalPremium || 0,
          afterPromoDiscount: quotation.discountedTotalFirstYrPremium || 0,
          firstYearDiscount: sqsQuotation?.totalFirstYearDiscount,
          perpetualDiscount: sqsQuotation?.totalPerpetualDiscount,
          discountType:
            coverage?.attributes?.discountedPremium?.firstYrDiscType ===
            "percent"
              ? "percentage"
              : coverage?.attributes?.discountedPremium?.firstYrDiscType ===
                "dollar"
              ? "dollar"
              : "",
          promoCode: quotation.promoCode,
          campaignCode: campaignDetail?.campaignCode,
          trackingCodeJson: new UrlAnalyticTrackingModel(analyticUrlParams)
            .trackingCodeJson,
          productCode: initValue?.plan, //quotation?.coverages[0].productCode,
          quotationRespData: quoteRawResponse
            ? JSON.stringify(quoteRawResponse)
            : "{}", //json str
          sourceBusiness: "",
          contractCurrency: "SGD",
          policyIllustrationPDFPath: "",
          agentSourceCode:
            advisorSelection === "USER_PREFERRED" ? agentCode.replace(' ', '') : "",
          agentSourceOfBusiness:  advisorSourceOfBusiness || rawAgentSourceOfBusiness,
          agentDetailsRespData:
            advisorSelection === "USER_PREFERRED"
              ? JSON.stringify(rawAgentDetailResponse)
              : "{}",
          agentOptionChosen: advisorSelection,
          planStructure:
            planDetails?.planStructure || sqsQuotation?.planStructure,
          formType: !!campaignDetail ? campaignDetail?.code : "MLO1",
          cpfMedisaveAmount: premiumPayment?.cpfMediSaveAmount,
          premiumTermOption:
            planDetails?.premiumTermOption || sqsQuotation?.premiumTermOption,
          premiumTermDesc:
            planDetails?.premiumTermDesc || sqsQuotation?.premiumTermDesc,
          partnerCode: campaignDetail?.partner,
          annualIncome: myInfoForm?.income, //incomeInfo?.income,
          exactDutiesOccupation: "", //incomeInfo?.duties,
          paymentMode: cpfAmt > 0 ? (ccAmt > 0 ? "CPF_CC" : "CPF") : "CC",
          sourceOfFunds: sourceOfFunds,
          transactionId,
          campaigns
        },
        payment: {
          cardHolderNric: get(personalDetails, "nric", null),
          cardHolderName: get(personalDetails, "fullName", null),
          bankId: Number(values["bank"]),
          paymentAmount: Number(totalPayablePremium).toFixed(2),
          // referenceNo: referenceNo, //reference no
          otherBank: values["others"],
        },
      };
      console.log("onSavePayment", payload);
      try {
        console.log("onSavePayment -> In Try");
        dispatch(setLoadingState(true));
        const response = await savePayment(payload);
        console.log("savePayment(payload) response", response);
        const refNo = get(response, "data", "");
        console.log("refno", refNo);
        console.log("savePayment", refNo);
        paymentPayload.referenceNumber = refNo;
        dispatch(updateReferenceNo(String(refNo)));
        if (!isCpfOnly) {
          postPayment(paymentPayload)
            .then((res: any) => {
              console.debug("postPayment", res);
              const paymentUrl = get(res, "data");

              console.log("paymentUrl", paymentUrl);
              // const params = new URLSearchParams(paymentUrl.split('?')[1]);
              // const refNo = params.get('referenceNumber');

              dispatch(updateCardHolderName(values["name"]));
              dispatch(updateBankId(Number(values["bank"])));
              dispatch(updateOtherBank(values["others"]));

              const fullPath =
                window.location.origin +
                window.location.pathname.replace("/index.html", "") +
                "#/mltc/payment?status=processing";
              console.log("fullPath", fullPath);
              console.log("isCpfOnly", isCpfOnly);

              dispatch(setLoadingState(true));
              window.open(paymentUrl, "_self");
            })
            .catch((err: any) => {
              dispatch(setLoadingState(false));
              console.log("postPayment() error", err);
              console.error(err);
              setHasError(true);
            });
        } else {
          dispatch(setLoadingState(false));
          onSuccessPayment(refNo);
          //history.push('/mltc/thank-you')
          // setTimeout(() => {
          //   window.open(fullPath, '_self');
          // }, 1000)
        }
      } catch (error) {
        dispatch(setLoadingState(false));
        console.log("onSavePayment() error", error);
        console.log("catch error", error);
      }
    },
    [
      dispatch,
      isCpfOnly,
      values,
      advisorSourceOfBusiness,
      agentCode,
      basicDetails,
      sqsQuotation,
      quoteRawResponse,
      personalDetails,
      retrieveMyInfo,
      advisorSelection,
      setLoading,
      agentInformationResponseRaw
    ]
  );

  const onSuccessPayment = useCallback(
    async (payload: any) => {
      dispatch(setLoadingState(true));
      try {
        const quotation: SQSPocketResponse = new SQSPocketResponse(
          quoteRawResponse
        );
        const coverage: Coverages | undefined = find(quotation.coverages, {
          type: "P",
        });
        const response = await getPolicyNo(payload, 3, retrieveMyInfo?.id);
        const policyNo = get(response, "data");
        if (policyNo) {
          dispatch(updatePolicyNo(String(policyNo)));
          dispatch(setLoadingState(false));
          trackOnLoad({ policyID: policyNo });
          sendMailMltc(payload, 3, retrieveMyInfo?.id); // , quotation.totalAftDisOriginalPremiumAmt, quotation.monthlyBenefit);
          history.push("/mltc/thank-you" + paramCC + analyticParam);
        } else {
          history.push("/mltc/something-wrong" + paramCC + analyticParam);
          dispatch(setLoadingState(false));
        }
      } catch (err) {
        // trackFormSubmmit(get(err, 'message'));
        dispatch(setLoadingState(false));
        history.push("/mltc/something-wrong" + paramCC + analyticParam);
      }
    },
    [dispatch, history, bankId, otherBank, quoteRawResponse, retrieveMyInfo]
  );

  const FAROptionHandler: React.MouseEventHandler<HTMLDivElement> = useCallback(
    async (e) => {
      // trackOnFormStartOrSuccess("DS_financial_adviser_form")
      const option = e.target as HTMLDivElement;
      const selectedOption = option?.getAttribute("data-far") || ''
      setAdvisorSelection(selectedOption);
      dispatch(updateAdvisorSelection(selectedOption));
    },
    [dispatch]
  );

  useEffect(() => {
    if (
      advisorSelection === "" &&
      previousAdvisorSelection &&
      previousAdvisorSelection === "USER_PREFERRED"
    ) {
      setAdvisorSelection(previousAdvisorSelection);
    }
  }, [advisorSelection, previousAdvisorSelection]);

  useEffect(() => {
    if (rawAgentDetailResponse && analyticUrlParams.arc && showArcPage) {
      setAdvisorSelection('USER_PREFERRED')
      setAgentCode(analyticUrlParams.arc)
    }
  }, [])
  
  if (rawAgentDetailResponse && analyticUrlParams.arc && showArcPage) {
    return <ArcForm onClickConfirmAndPay={onClickConfirmAndPay}/>; 
  }  

  const stepsList: Step[] = [
  {
    label: "Basic Info",
    isCurrentStep: false,
    path: "/mltc/lets-get-started",
    disabled: validQRClient
  },
  {
    label: "Quote",
    isCurrentStep: false,
    path: "/mltc/choose-plan",
  },
  {
    label: "Health Declaration",
    isCurrentStep: false,
    path: "/mltc/health",
    disabled: gioDeclaration === "GIO",
  },
  {
    label: "Start Application",
    isCurrentStep: false,
    path: "/mltc/my-info",
  },
  {
    label: "Review & Payment",
    isCurrentStep: true,
    path: "/mltc/review",
  },
];

  return (
    <Container>
      <FormContainer
        maxWidth={"891px"}
        ref={advisorSelectionFormRef}
        margin={"150px auto 50px auto"}
      >
        <InnerContainer>
          <div style={{ maxWidth: "588px", margin: "auto" }}>
            <Header>
              Do you need a Financial Adviser Representative to service this
              policy?
            </Header>
          </div>
          <ButtonNFarSearch>
            <ButtonContainer onClick={FAROptionHandler}>
              <RectSelector
                data-far="NO_AGENT"
                isSlected={advisorSelection === "NO_AGENT"}
              >
                No, I do not need an adviser
              </RectSelector>

              <RectSelector
                data-far="ARISTOTLE"
                isSlected={advisorSelection === "ARISTOTLE"}
              >
                Yes, assign an adviser to me
              </RectSelector>
              <RectSelector
                data-far="USER_PREFERRED"
                isSlected={advisorSelection === "USER_PREFERRED"}
              >
                Yes, I want to assign my own adviser
              </RectSelector>
            </ButtonContainer>
            <FARSearchContainer isShow={advisorSelection === "USER_PREFERRED"}>
              <div>
                <div>
                  <InputGroup
                    id="far-code"
                    inputProps={{
                      textAlign: "left",
                      value: agentCode,
                    }}
                    theme={themeDefault}
                    onChange={onAgentCodeChange}
                    inputType="input"
                    label="Financial Adviser Representative Code"
                  />
                  {advisorName && agentCodeFormMsg && (
                    <div className="adviser-res">{agentCodeFormMsg}</div>
                  )}
                  {!isAdvisorFound && agentCodeFormMsg ? (
                    <div className="adviser-res adviser-error">{agentCodeFormMsg}</div>
                  ) : null}
                </div>
                <Button
                  label="Find adviser"
                  disabled={agentCode.length < 9}
                  data-far="own-adviser"
                  onClick={onClickVerify}
                  theme={themeDefault}
                  variant="secondary"
                />
              </div>
            </FARSearchContainer>
          </ButtonNFarSearch>
        </InnerContainer>
        <ContinueContainer>
          <Button
            theme={themeDefault}
            width="180px"
            onClick={() => {
              if (advisorSelection === "USER_PREFERRED") {
                trackOnLoad({ formName: "mltc_agency_code_form" });
                trackOnAgencySelection(advisorSelection, "Agent");
              } else if (
                advisorSelection === "ARISTOTLE" ||
                advisorSelection === "NO_AGENT"
              ) {
                trackOnAgencySelection(advisorSelection, "Direct");
                dispatch(updateAgentDetailResponseRaw(null));
              }
              isInvalidArcCodeFromUrl && dispatch(setInvalidArcCodeFromUrl(false));
              
              console.log("PROCEED TO PAYMENT GATEWAY");
              onClickConfirmAndPay();
            }}
            disabled={advisorSelection === 'USER_PREFERRED' ? !isAdvisorFound : !Boolean(advisorSelection)}
            label="Continue"
          />
        </ContinueContainer>

        <AccordionContainer>
          <Accordion {...accordionArgs}>
            <div style={{ paddingBottom: "20px" }}>
              <Bullet>
                <Text theme={themeDefault} className={AccordionParagraph}>
                  If you are an existing Singlife customer, we’ll assign the
                  latest active representative, either from Singapore Life Ltd.
                  or from our distribution partners, who had sold our plans to
                  you.
                  <br />
                  <br />
                  Please note: For Disability Support Programme (DSP) members,
                  we’ll assign you the financial adviser representative whom you
                  have signed up the DSP with.
                </Text>
              </Bullet>
              <Bullet>
                <Text theme={themeDefault} className={AccordionParagraph}>
                  If you are a new customer of Singlife or don’t have an active
                  representative who have sold a Singlife plan to you, we’ll
                  assign a dedicated Singlife Relationship Consultant.
                </Text>
              </Bullet>
              <Text theme={themeDefault} className={AccordionParagraph}>
                Once you’ve completed your purchase, we’ll email you the details
                of the assigned financial adviser representative who will be
                servicing your policy.
              </Text>
            </div>
          </Accordion>
        </AccordionContainer>
      </FormContainer>

      <div ref={SpacerRef}></div>

      <Stepper steps={stepsList}></Stepper>

      <BottomSheet />
    </Container>
  );
};

export default Advisor;

const Container = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1230px;
  display: block;
  flex-wrap: wrap;
  padding: 0 24px;
  @media screen and (min-width: 1024px) {
    padding: 0 195px;
  }
  @media screen and (min-width: 768px) {
  }
`;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const IconCss = css`
  position: relative;
  top: 4px;
  right: 5px;
`;
const ErrorIconCss = css`
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  right: 5px;
`;

const FormContainer = styled.div<FormContainerProps>`
  flex-direction: column;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 200px auto 100px auto;
  max-width: 327px;
  transition: all 0.2s ease;

  @media screen and (min-width: 768px) {
    max-width: 792px;
    margin: 200px auto 50px auto;
  }
  @media screen and (min-width: 1250px) {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
    margin: ${(props) => (props.margin ? props.margin : "150px auto 0 auto")};
  }
`;
const FormHeaderContainer = styled.div<FormHeaderContainerProps>`
  display: block;
  margin: auto;
  margin-bottom: 24px;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "792px")};

  @media screen and (min-width: 768px) {
    margin-bottom: 64px;
  }
`;
const FormContentContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  flex-direction: row;
  column-gap: 30px;
  margin: auto;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const FormAgencyContentContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  width: 100%;
  display: block;
  margin: auto;
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  padding: 0;
  margin: 0;
  margin-bottom: 12px;

  @media screen and (min-width: 768px) {
    /* margin: 0 50px; */
    max-width: 792px;
    margin-bottom: 16px;
  }
  @media screen and (min-width: 1024px) {
    margin: 0
      ${(props) => (props.marginHorizontal ? props.marginHorizontal : "0")};
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "792px")};
    margin-bottom: 16px;
  }
`;

const FormHeaderDescriptionContainer = styled.div<FormHeaderTitleContainerProps>`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "588px")};

  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 0;
  }
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 80px;
  column-gap: 40px;
  @media screen and (max-width: 768px) {
    column-gap: 0;
    row-gap: 10px;
    margin-top: 40px;
    flex-direction: column;
    align-items: center;
  }
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  @media screen and (max-width: 768px) {
    font-weight: 400;
  }
`;

const HeaderResponseDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-weight: 400;
  }
`;

const AccordionContainer = styled.div`
  max-width: 792px;
  margin: auto;
  margin-top: 120px;
  @media screen and (max-width: 768px) {
  }
`;
const AccordionParagraph = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 180%;
  color: #434343;
`;

const container_default_css = css`
  margin-bottom: 0px;
`;
const title_default_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 16px;
  }
`;

const FormLinkContainer = styled.div`
  display: block;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;

const FormLinkCss = css`
  font-style: normal;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  color: #883e89;
`;

export interface FormContainerProps {
  margin?: string;
  maxWidth?: string;
}
export interface MessageNoteProps {
  color?: string;
}
export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal?: string;
  maxWidth?: string;
}
export interface ModalContainerProps {
  display?: boolean;
}

export interface FormHeaderContainerProps {
  margin?: string;
  maxWidth?: string;
}
const accordionArgs = {
  theme: themeDefault,
  className: container_default_css,
  title:
    "Things to note if Singlife assigns a financial adviser representative to you:",
  titleClassName: title_default_css,
  titleFontSize: 16,
  headerPadding: "24px 24px 24px 0",
  isExpanded: true,
  showBottomLine: true,
  showHeaderLine: true,
  bottomLineColor: "#c4c4c4",
  bottomLineThickness: "1px",
  contentMarginLeft: "0px",
  contentMarginRight: "0px",
  bottomLineClassName: "margin:10px",
};

const ContinueContainer = styled.div`
  margin: 64px auto;
  display: flex;
  justify-content: center;
  button:disabled {
    background-color: #d4bfd7;
    color: white;
  }
`;

const Header = styled.div<{ marginTop?: string }>`
  max-width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  color: #434343;
  font-size: 18px;
  margin: 0 auto 24px auto;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 64px;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const FARSearchContainer = styled.div<{ isShow: boolean }>`
  width: 100%;
  margin-top: 24px;
  height: ${(props) => (props.isShow ? "100%" : "0px")};
  overflow: hidden;
  transition: all 0.3s linear;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    height: ${(props) => (props.isShow ? "120px" : "0px")};
  }
  div {
    width: 100%;
    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      display: flex;
    }
    div:first-child {
      flex: 2;
      display: flex;
      flex-direction: column;
      div > label {
        margin-bottom: 10px;
      }
      .adviser-res {
        color: #19d3c5;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        padding-bottom: 10px;
        line-height: 140%; /* 16.8px */
        letter-spacing: 0.18px;
        margin-top: 8px;
        @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
          margin-bottom: 10px;
        }
      }
      .adviser-error {
        color: #c50000;
      }
    }
    button {
      flex: 1;
      margin-top: 25px;
      @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
        margin-top: 10px;
        margin-left: 24px;
      }
    }
  }
`;
const ButtonNFarSearch = styled.div`
  max-width: 664px;
  padding: 0px 20px;
  margin: auto;
`;

const RectSelector = styled.div<{ isSlected: boolean }>`
  max-width: 616px;
  font-size: 14px;
  width: inherit;
  border-radius: 8px;
  text-align: center;
  padding: 15px 24px;
  margin: auto 20px;
  font-weight: 600;
  background-color: ${(props) =>
    props.isSlected
      ? themeDefault.colors.primary
      : themeDefault.colors.grey[700]};
  color: ${(props) =>
    props.isSlected
      ? themeDefault.colors.white
      : themeDefault.colors.grey[1200]};
  transition: background-color 0.2s linear;
  cursor: pointer;
  &:hover {
    background-color: #883E89;
    color: #FFFFFF;
  }
`;

const dataMock = {
  status: true,
  responseErrorDetail: "Test",
  totalPages: 3,
  totalItems: 3,
  logoutUser: false,
  data: {
    clientNum: "ClientNum-123",
    clientType: "Test Client",
    surname: "Test",
    salutation: "Ms",
    fullName: "",
    nric: "A444444U",
    dob: "24-09-1988",
    gender: "M",
    maritalStatus: "Single",
    nationality: "SGPrean",
    race: "SG",
    homeNum: "44445",
    mobileNum: "00009999000",
    officeNum: "333",
    faxNum: "223",
    emailId: "Test@gmail.com",
    residential_Addr_1: "addr 1",
    residential_Addr_2: "addr 2",
    residential_Addr_3: "add1212312",
    residential_Addr_4: "addr 4",
    residential_Addr_5: "addr 5",
    residentialAddrCountry: "SG",
    residentialAddrPostalCode: "444",
    agentTerminatedFlag: "Y",
    givename: null,
  },
};
